import type { IconNames } from '@shared/ui/icon';

import type { ValuesOf } from './values-of';

export const LayoutType = {
  Masonry: 'masonry',
  Fixed: 'fixed',
  Relative: 'relative',
  Single: 'single',
  Slider: 'slider',
} as const;
export type LayoutType = ValuesOf<typeof LayoutType>;

export type ToggleButtonItem = {
  value: LayoutType;
  icon: IconNames;
  isHiddenMobile?: boolean;
};
